var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurger({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 0H0.625C0.279813 0 0 0.4477 0 1C0 1.5523 0.279813 2 0.625 2H15.375C15.7202 2 16 1.5523 16 1C16 0.4477 15.7202 0 15.375 0Z",
    fill: "#D4AF37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 7H0.625C0.279813 7 0 7.4477 0 8C0 8.5523 0.279813 9 0.625 9H15.375C15.7202 9 16 8.5523 16 8C16 7.4477 15.7202 7 15.375 7Z",
    fill: "#D4AF37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 14H0.625C0.279813 14 0 14.4477 0 15C0 15.5523 0.279813 16 0.625 16H15.375C15.7202 16 16 15.5523 16 15C16 14.4477 15.7202 14 15.375 14Z",
    fill: "#D4AF37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.b2e5a8a0.svg";
export { ForwardRef as ReactComponent };